import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {SpotfightEvent} from "../core/models/models";
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private httpClient: HttpClient) {
  }

  async getAllEvents(): Promise<SpotfightEvent[]> {
    return firstValueFrom(this.httpClient.get<SpotfightEvent[]>(environment.apiUrl + "events/"));
  }

  async getNextEvents(): Promise<SpotfightEvent[]> {
    return firstValueFrom(this.httpClient.get<SpotfightEvent[]>(environment.apiUrl + "events/list-next"));
  }

  async getLastEvents(): Promise<SpotfightEvent[]> {
    return firstValueFrom(this.httpClient.get<SpotfightEvent[]>(environment.apiUrl + "events/list-past"));
  }

  async getLiveEventsForLeague(league: string): Promise<SpotfightEvent[]> {
    return firstValueFrom(this.httpClient.get<SpotfightEvent[]>(environment.apiUrl + `events/league/${league}/live`));
  }

  async getAllEventsWithNonLives(): Promise<SpotfightEvent[]> {
    return firstValueFrom(this.httpClient.get<SpotfightEvent[]>(environment.apiUrl + "events/non-live"));
  }

  async getEvent(league: string, uuid: string): Promise<SpotfightEvent> {
    return firstValueFrom(this.httpClient.get<SpotfightEvent>(environment.apiUrl + `events/league/${league}/${uuid}`));
  }

  async updateEvent(event: SpotfightEvent): Promise<SpotfightEvent> {
    return firstValueFrom(this.httpClient.post<SpotfightEvent>(environment.apiUrl + `events/league/${event.league}/${event.uuid}`, event))
  }

  async createNewEvent(event: SpotfightEvent): Promise<SpotfightEvent> {
    return firstValueFrom(this.httpClient.post<SpotfightEvent>(environment.apiUrl + "events/create", event))
  }

  async goLive(event: SpotfightEvent): Promise<Object> {
    return firstValueFrom(this.httpClient.post(environment.apiUrl + `events/go-live/${event.league}/${event.uuid}`, {}))
  }
}
